import React from 'react';
//import PropTypes from 'prop-types';
import {
  Label,
} from 'reactstrap';
import Services from '../services';
import _ from 'lodash';
import Select from 'react-select/async';
import DropZone from 'react-dropzone';
import { ImageCard } from '../../../commons/controls';
import SelectField from '../../../components/Form/SelectField';


const PromociokForm = props => {
  const {
    angolNyelv,
    formEloadas,
    formHelyszinek,
    formObjects,
    formObjectsAngol,
    onDropObjects,
    onDeleteClick,
    handleSelectInputChange,
    handleImgClick,
  } = props;

  const loadEloadasOptions = (input, callback) => {
    Services.listEloadas(input, (err, res) => {
      if (!err) {
        let options = [];
        res[0].forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadHelyszinOptions = (input, callback) => {
    Services.listHelyszinSelect((err, res) => {
      if (!err) {
        let options = [];
        res[0].forEach((item) => {
          options.push(item);
        });
        callback(options);

        if(!input && formHelyszinek.length === 0 && options.length === 1) {
          handleSelectInputChange(options[0], 'formHelyszinek');
        }
      }
    });
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12" style={{paddingRight: '2px'}}>
          <SelectField
            styles={{
              control: base => ({
                ...base,
                '&:focus': { borderColor: 'red' }, // border style on hover
                border: '1px solid lightgray', // default border color
                boxShadow: 'none', // no box-shadow
                borderRadius: '0'
              }),
            }}
            variant="async"
            label="Előadás:"
            name="formEloadas"
            id="formEloadas"
            placeholder="Kezdj el gépelni..."
            noOptionsMessage={() => 'Nincs keresési eredmény'}
            onChange={v => handleSelectInputChange(v, 'formEloadas')}
            loadOptions={_.debounce(loadEloadasOptions, 1000)}
            getOptionLabel={option => option.cim}
            getOptionValue={option => option.id}
            value={formEloadas}
            cache={false}
            isLoading={false}
            isClearable
            defaultOptions
            required
            />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12" style={{paddingRight: '2px'}}>
          <SelectField
            styles={{
              control: base => ({
                ...base,
                '&:focus': { borderColor: 'red' }, // border style on hover
                border: '1px solid lightgray', // default border color
                boxShadow: 'none', // no box-shadow
                borderRadius: '0'
              }),
            }}
            variant="async"
            label="Helyszín:"
            name="formHelyszinek"
            id="formHelyszinek"
            placeholder="Kezdj el gépelni..."
            noOptionsMessage={() => 'Nincs keresési eredmény'}
            onChange={v => handleSelectInputChange(v, 'formHelyszinek')}
            loadOptions={_.debounce(loadHelyszinOptions, 1000)}
            getOptionLabel={option => option.nev}
            getOptionValue={option => option.id}
            value={formHelyszinek}
            cache={false}
            isLoading={false}
            isMulti
            isClearable
            defaultOptions
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Label> Képek: </Label>
          <DropZone multiple onDrop={(files) => onDropObjects(files, 'hu')} className="custom-dropzone" style={{ height: '50px' }} accept="image/*">
            {({getRootProps, getInputProps}) => (
              <div {...getRootProps({ className: 'custom-dropzone'})}>
                <input {...getInputProps()} />
                <div className="dropzone-text">
                  {'Kép feltöltése!'}
                </div>
              </div>
            )}
          </DropZone>
        </div>
      </div>
      <div className="row">
        {formObjects && formObjects.map((item, idx) => {
          return (
            <div className="col-md-12" key={idx.toString()}>
              <ImageCard
                //style={{maxWidth: '200px'}}
                poster
                key={idx.toString()}
                mime={item.mime}
                title={item.docname}
                content={item.content}
                main={item.main}
                src={item.src}
                style={{ height: "200px" }}
                onViewClick={v => handleImgClick(item, idx)}
                onDeleteClick={v => onDeleteClick(item, 'hu')}
              />
            </div>
          );
        })}
      </div>
      {angolNyelv && 
        <div>
          <div className="row">
            <div className="col-md-12">
              <Label> Képek (angol): </Label>
              <DropZone multiple onDrop={(files) => onDropObjects(files, 'en')} className="custom-dropzone" style={{ height: '50px' }} accept="image/*">
                {({getRootProps, getInputProps}) => (
                  <div {...getRootProps({ className: 'custom-dropzone'})}>
                    <input {...getInputProps()} />
                    <div className="dropzone-text">
                      {'Kép feltöltése!'}
                    </div>
                  </div>
                )}
              </DropZone>
            </div>
          </div>
          <div className="row">
            {formObjectsAngol && formObjectsAngol.map((item, idx) => {
              return (
                <div className="col-md-12" key={idx.toString()}>
                  <ImageCard
                    //style={{maxWidth: '200px'}}
                    poster
                    key={idx.toString()}
                    mime={item.mime}
                    title={item.docname}
                    content={item.content}
                    main={item.main}
                    src={item.src}
                    style={{ height: "200px" }}
                    onViewClick={v => handleImgClick(item, idx)}
                    onDeleteClick={v => onDeleteClick(item, 'en')}
                  />
                </div>
              );
            })}
          </div>
        </div>
      }
    </React.Fragment>
  )
  
}

export default PromociokForm;